import { useState, useCallback, useEffect } from 'react';
import { INotification } from 'utils/types';

export const VISIBLE_TIME = 3000;

export const useNotification = () => {
  const [notification, setNotification] = useState<INotification | undefined>(
    undefined,
  );

  const removeNotification = () => setNotification(undefined);

  const addNotification = (notification: INotification) =>
    setNotification(notification);

  useEffect(() => {
    if (notification) {
      setTimeout(() => {
        setNotification(undefined);
      }, VISIBLE_TIME);
    }
  }, [notification]);

  return {
    notification,
    addNotification: useCallback(
      (notification: INotification) => addNotification(notification),
      [],
    ),
    removeNotification: useCallback(() => removeNotification(), []),
  };
};

export default useNotification;
